import { Campaign } from '../types/campaign.types';
import { handleRequest } from '../utils/handle-request';

import { privateClient } from './api-client';

export const sharedApi = {
  campaigns: async () => {
    const campaigns = await privateClient.get('campaigns/').json<Campaign[]>();

    return campaigns.sort((a, b) => a.year - b.year);
  },
  cgu: async () => {
    const cgu = await privateClient.get('accounts/tutorial/').json<{
      file: string;
    }>();

    return cgu;
  },

  getFarms: async () => {
    const res = await handleRequest<{ id: number; name: string }[]>(
      privateClient.get('farms/').json(),
    );

    return res.map((farm) => ({
      value: farm.id.toString(),
      label: farm.name,
    }));
  },

  getComputationStatus: async (requestId: number) => {
    return privateClient.get(`computation_requests/${requestId}/`).json<{
      id: number;
      status: string;
      instance_id: number;
    }>();
  },
};
